import React, { useState, useEffect } from "react";

export const OfflineIndicator: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    updateOnlineStatus();

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-40">
      <div className="bg-white border rounded-lg shadow-lg p-3 max-w-xs border-red-200">
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 rounded-full bg-red-500" />

          <div className="flex-1 min-w-0">
            <div>
              <p className="text-sm font-medium text-red-900">Offline</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
